import React from 'react'

import { ReactComponent as MinimizeIcon } from 'assets/svg/shared/minimize.svg'

export function MinimizeButton(props) {
    const {
        width = '28px',
        height = 'auto',
        imgHeight = '28px',
        marginLeft = '0',
        marginRight = '-7px',
        onClick = () => {},
        className = 'minimize-button'
    } = props

    return (
        <button
            type="button"
            className={className}
            style={{ width, height, marginLeft, marginRight }}
            onClick={onClick}
        >
            <MinimizeIcon height={imgHeight} />
        </button>
    )
}
